// extracted by mini-css-extract-plugin
export var navbarSubLink = "S_gb d_gb d_f4 d_Z d_cb d_dl d_br d_bS";
export var menuLink = "S_xr d_f0 d_dz";
export var subPageLink = "S_gf d_gf";
export var burger = "S_xV";
export var sublinkSize = "S_xW";
export var linkSize = "S_xX";
export var Link = "S_vs F_vs F_tN F_t6";